import { databaseRef, storageRef } from 'config'
import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const uploadImage = (
  image: Blob,
  userId?: string,
  successCallback: (url: string) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  const name = `user_avatars/${+new Date()}.jpeg`

  storageRef
    .child(name)
    .put(image)
    .then(snapshot => snapshot.ref.getDownloadURL())
    .then(url => {
      if (userId) {
        databaseRef.child(`users/${userId}/avatar_url`).set(url)
        dispatch(action(USER_ACTION_TYPES.update_image, { url }))
      }
      successCallback(url)
    })
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
}



// WEBPACK FOOTER //
// ./src/store/user/actions/uploadImage.action.ts